export enum WeightUnit {
    POUND = "lb",
    KG = "kg"
}